import {NgbTabChangeEvent,NgbTabset,NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit,NgZone,ViewChild, PLATFORM_ID, Inject, Input, Output, EventEmitter, OnChanges, ElementRef } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import {commonService} from "../../service/common.service";
import { sessionService } from '../../service/session.service';
import { ToppersService } from '../../service/toppers.service';

import { Globals } from '../../globals';
import { FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-addtoppersdetail',
  templateUrl: './addtoppersdetail.component.html',
  styleUrls: ['./addtoppersdetail.component.css'],  
  providers:[NgbTabsetConfig,NgbTabset,sessionService,Globals,ToppersService]
})
export class AddtoppersdetailComponent implements OnInit {
  @ViewChild('stepper') private myStepper: MatStepper;
  isLinear:boolean = false;
  firstFormGroup:FormGroup;
  secondFormGroup:FormGroup;
  thirdFormGroup:FormGroup;
  forthFormGroup:FormGroup;
  lastinseredId:Number=0;
  userId:Number;
  topperslistDagta:any;
  msg:any='';   
  catdata:Array<any>=[];
  userData:any=[];
  length:Number=0;
  start=0;
  end=10;
  selectUser:Array<any>=[];
  avatarImg=false;
  score=false;
  inputtypeFile:String='';
  attachment:any = 0;
  nValue:String='';
  scoreCardImgId:any = '';
  attachmentArray:any={};
  scoreCardImgIdArray:any=[];
  streambox:any;
  catType:any = 'ESE';

  constructor(private fb: FormBuilder,private ts:ToppersService,public commonService:commonService,private route: ActivatedRoute,private global:Globals,private _snackBar: MatSnackBar) { 
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.topperslistDagta={};
    this.attachmentArray.uploadname = '';
  }
imgpath=this.global.toppersUrl;
toppersUrl =this.global.siteUrl+'file/upload?folder='+this.global.toppersFolder+'&mediaFor=toppers';
  uploader:FileUploader=new FileUploader({url:this.toppersUrl,authToken:sessionStorage.getItem('_to')});
  fileExt: string = "JPG, JPEG, PNG,png,pdf";

loginform(){
  this.commonService.setLoginBox(true); 
}
 
  ngOnInit() { 

    this.getStreamList();
    this.commonService.profile.subscribe((data:any)=>{
      if(data && Object.keys(data).length != 0 && data != null){
        this.userData=data;
        this.userId = this.userData.id;
        this.length = Object.keys(data).length;
        this.ts.getTopperDetailsById(this.userData.id).subscribe((dataum : any)=>{
        if(dataum.results != null ){ 
          this.userId = this.userData.id;       
          this.lastinseredId = dataum.results.id; // assigned to lastinserted id...
          this.topperslistDagta = dataum.results;
           this.attachmentArray.uploadname=dataum.results.avatar;
           this.scoreCardImgIdArray.uploadname=dataum.results.scorecard;
        } else{
          this.userId = this.userData.id; 
          this.topperslistDagta = {};
        }    
    });
  }  
  })

    this.ts.getTopperCatLIsting(this.start,this.end,'1').subscribe((data:any)=>{
      if(data){     
        this.catdata = data.results.rows;      
      }else{
        this.catdata=[];      
      }
      })
      this.firstFormGroup = this.fb.group({
        name: ['', Validators.required],
        examCatId: [''],
        passedYear: [''],
        rank: [''],
        age: [''],
        collegeOfGraduation: [''],
        yearOfGraduation: [''],
        graduationCGPA: [''],
        collegeCity: [''],
        postGraduation: [''],
        workExperience: [''],
        detailsOfCoaching: [''],
        hometownCity: [''],
        schoolingMedium: [''],
        servicePreference: [''],
        previousSelection: [''],
        class10Perc:[''],
        class12Perc:[''],
        preferredBooksMaterials:[''],
        onlinePlatformForLearning:[''],
        // avatar: [''],
        // scorecard: [''],       
        streamId: [''] 
  
      });
      this.secondFormGroup = this.fb.group({
        aboutYourself: [''],
        dailyRoutine: [''],
        selectiveTextBook: [''],
        testSeriesAndRevision: [''],
        openionAboutOnlineTS: [''],
        scoreInTS: [''],
        separatePreparation: [''],
        approachForESEPre: [''],
        strategyForESEMains: [''],
        GATENumericalAnswer: [''],
        selfNotesForRevision: [''],
        electronicVsPaperMaterial: [''],
        approachForESEPreTechnical: [''],
        fixedSpaceAnsSheet:[''],
        profileInsecurity:[''],
        otherSuggestions:[''],
        workingProfessional:[],
        aboutInterview:[''],
        selectedInterviewQuestion:[''],
        mockInterviews:[''],
        finalSelection:[''] 
      });
  
      this.thirdFormGroup = this.fb.group({
        onlineHoursPredection: [''],
        hoursForSocialMedia: [''],
        internetForPrepration: [''],
        devicesForOnlineStudy: [''],
        refreshBreakFromStudies: [''],
        mustDoNDontInLastMonth: [''],
        electronicVsPaperMaterial:[''],
        selfNotesForRevision:[''],
        aboutPreviousAttempt:[''],
        studyMomentum: [''],
  
      });
      this.forthFormGroup = this.fb.group({
        separatePreparation:[''],
        quittingOrBackup: [''],
        motivation: [''],
        tipsToTheAspirants: [''],
        advice: [''],
       // isActive: ['', Validators.required],
       // isApproved: ['', Validators.required],
      });
    

  }

//  get stream
getStreamList(){
  this.ts.streamlist().subscribe((data : any)=>{     
    if(data.error==0){ 
      this.streambox = data.results;   
    }
});
}

  form1(){  
    if(this.firstFormGroup.status!='INVALID' && this.attachmentArray.uploadname.length>0){
        if(this.lastinseredId){
            // console.log('update data',this.firstFormGroup.value);
              this.firstFormGroup.value.userId = this.userId;
              if(this.attachment){this.firstFormGroup.value.attachId = this.attachment; this.firstFormGroup.value.avatar = this.attachmentArray.uploadname}
              if(this.scoreCardImgId){this.firstFormGroup.value.scoreCard = this.scoreCardImgId;}
              this.ts.updateToppersdetail(this.firstFormGroup.value,this.lastinseredId,).subscribe((data : any)=>{
              if(data.error==0){
                this.firstFormGroup.value.attachId='';
            // console.log('updated successfully');      
          }
          });
        }else{
        // console.log('addT');
        // console.log('add data',this.firstFormGroup.value);    
              this.firstFormGroup.value.userId = this.userId;
              if(this.attachment){this.firstFormGroup.value.attachId = this.attachment; this.firstFormGroup.value.avatar = this.attachmentArray.uploadname}
              if(this.scoreCardImgId){this.firstFormGroup.value.scoreCard = this.scoreCardImgId;}
              this.ts.addToppersDetail(this.firstFormGroup.value).subscribe((data : any)=>{
              if(data.error==0){ 
                this.firstFormGroup.value.attachId='';
              this.lastinseredId=data.results;
              //console.log('updated successfully');       
          }
          });
        } this.myStepper.next();
    }else{
      alert('Required fields are empty!');
    }
  }
  form2(){       
   if(this.lastinseredId){     
     this.ts.updateToppersdetail(this.secondFormGroup.value,this.lastinseredId).subscribe((data : any)=>{
       if(data.error==0){
    }
    });
  }}

  form3(){
      if(this.lastinseredId){    
      this.ts.updateToppersdetail(this.thirdFormGroup.value,this.lastinseredId).subscribe((data : any)=>{
       if(data.error==0){
    }
    });
  }}
  form4(){   
    if(this.lastinseredId){ 
  
      this.ts.updateToppersdetail(this.forthFormGroup.value,this.lastinseredId).subscribe((data : any)=>{
        if(data.error==0){  
          this.openSnackBar('Your datails are saved successfully. Administrator will review and publish it.', 'Successful');
        // console.log('updated successfully');       
         this.msg='Data Save successfully';        
     }
     });
   }
   }

  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });
  
      this.uploader.onCompleteAll=function (){
       // console.log(this.uploader);
       // console.log("Complete Upload");
      }
   }


   openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
    });
  }

   onFileChanged(event,fileName) {
      //FileUploader.queue[0].FileItem.file
      //this.attachment= 0;
      //this.scoreCardImgId= 0;
      this.nValue = fileName;
   // console.log('uploader',this.uploader.queue); // extract file name
  //   console.log('event',event);
     //var idAttr = event.target.attributes.id;
      //this.nValue = idAttr.nodeValue;
    
    //  if(this.nValue == 'avatar'){
    //   this.avatarImg= true;       
    //   }
    //  if (this.nValue == 'scorecard'){
    //   this.score= true;         
    //   }        
   // console.log('toppersUrl',this.toppersUrl);
    this.uploader.uploadAll();
   }
  
   onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
     //console.log("Success");
     // console.log(item);
      let data = JSON.parse(response); //success server response      
        if(data.error==0){
         
         console.log('server Response',data.result,this.nValue);
         if(this.nValue == 'avatar'){
            this.attachment = data.result.id;
            this.attachmentArray = data.result;
           
        
          }  
         if(this.nValue == 'scorecard'){ 
           this.scoreCardImgId = data.result.id; 
           this.scoreCardImgIdArray= data.result;            
        } 
      //  console.log('scorecardID',this.scoreCardImgId); 
      //  console.log('avatarId',this.attachment);  
        //console.log(data.result.id);   
            
         // console.log(this.avatar);searchUser
         this.uploader.queue=[];
        }         
    }
  
    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        if(response){          
      let error = JSON.parse(response); //error server response
        }
    } 

    // removeimg(event){
    //   if(event == 'avatar'){
    //     this.attachmentArray=[];
    //     this.attachment =0;
    //   }else{
    //     this.scoreCardImgIdArray=[];
    //     this.scoreCardImgId =0;
    //   }
    // }

    setCategory(id){
      this.catType = Object.keys(this.global.ToppersCat).find(key => this.global.ToppersCat[key] == id);
  }
  }

 




// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/addtoppersdetail/addtoppersdetail.component.ts